const ALL_PHOTOS_KEY = undefined;

// a print is a photo with quantity
function sizeHasPrints(size) {
  size || (size = {});

  return (size.photos || []).some(photo => photo.quantity);
}

function sizeHasRootImage(size, imageID) {
  size || (size = {});
  imageID = parseInt(imageID, 10);

  return (size.photos || []).some(
    photo => photo.quantity && photo.root_image_id === imageID
  );
}

// a photo is just a photo regardless of quantity
function sizeHasPhotos(size) {
  size || (size = {});

  return (size.photos || []).length > 0;
}

function stripZeroQuantityPhotosFromSize(size) {
  if (!size) return;

  size = { ...size };
  size.photos = size.photos.filter(photo => photo.quantity);

  return size;
}

function defaultSize(sizes) {
  return sizes.find(size => size.default);
}

function individual(photo, size) {
  return { ...photo, size };
}

function collection(photos, size) {
  return photos.map(photo => individual(photo, size));
}

function fromCollection(sizes) {
  return sizes.reduce(
    (memo, size) => memo.concat(collection(size.photos, size)),
    []
  );
}

export default {
  ALL_PHOTOS_KEY,
  sizeHasPrints,
  sizeHasPhotos,
  stripZeroQuantityPhotosFromSize,
  sizeHasRootImage,
  defaultSize,
  augment: {
    individual,
    collection,
    fromCollection,
  },
};
